import React from 'react';
import { Modal, Spin, Avatar,Image,Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, UserOutlined, 
        PictureOutlined, EyeOutlined} from '@ant-design/icons';
import { FaExternalLinkAlt } from 'react-icons/fa';
import * as Styled from './style.js';

const SummaryModal = ({ 
  visible, 
  onClose, 
  loading, 
  sessionData 
}) => {

  const renderGroupfie = () => {
    if (sessionData?.groupfie && sessionData.groupfie !== 'N/A') {
      return (
        <div className='show-preview-icon'>
          <Image 
            src={sessionData.groupfie} 
            alt="Group Photo" 
            className="groupfie-image"
            preview={{
              mask: (
                <div className="preview-icon-overlay">
                  <EyeOutlined/>
                  <span>Click To Preview</span>
                </div>
              )
            }}
          />
        </div>
      );
    }
    return (
      <div className="groupfie-placeholder">
        <PictureOutlined />
      </div>
    );
  };

  return ( 
    <Modal
      title={ sessionData && sessionData.session_start ?
       `Session Summary : ${sessionData?.session_start}` : 'Session Summary'}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
    >
      <Spin spinning={loading}>
        {sessionData && (
          <Styled.ModalContainer>
            <div className="groupfie-container">
              {renderGroupfie()}
            </div>
            <div className="batch-name-section">
              {sessionData.batch_name}
              {sessionData?.batch_id && (
                <Tooltip title="View Session List">
                  <a
                    href={`https://cm.sporthood.in/#/fixtures/${sessionData.batch_id}/session`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className='venueTitle'
                  >
                    <FaExternalLinkAlt />
                  </a>
                </Tooltip>
              )}
            </div>

            {sessionData?.coaches?.length > 0 && (
              <div className="coaches-section">
                {sessionData.coaches.map((coach, index) => (
                  <div key={index} className="coach-bubble">
                    <Avatar
                      size={32}
                      src={coach.image}
                      icon={<UserOutlined />}
                    />
                    <span>{coach.name}</span>
                  </div>
                ))}
              </div>
            )}

            <div className="status-section">
              <div className={`status-bubble ${sessionData.attendance_marked ? 'status-success' : 'status-error'}`}>
                {sessionData.attendance_marked ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                <span>Attendance {sessionData.attendance_marked ? 'Marked' : 'Not Marked'}</span>
              </div>
              
              {sessionData.groupfie_uploaded !== null && (
                <div className={`status-bubble ${sessionData.groupfie_uploaded ? 'status-success' : 'status-error'}`}>
                  {sessionData.groupfie_uploaded ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                  <span>Groupfie {sessionData.groupfie_uploaded ? 'Uploaded' : 'Not Uploaded'}</span>
                </div>
              )}
            </div>

            <div className="details-section">
              <div className="detail-row">
                <span className="detail-label">Customers</span>
                <span className="detail-value">{sessionData.total_customers}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Demos</span>
                <span className="detail-value">{sessionData.demos}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Customers Without Valid Subscription</span>
                <span className="detail-value">{sessionData.customers_without_valid_subscription}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Total</span>
                <span className="detail-value">{sessionData.customers_attended}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Faces in Groupfie</span>
                <span className="detail-value" 
                  style={{color: sessionData.faces_in_groupfie == sessionData.customers_attended ? '' : 'red'}}
                >
                  {sessionData.faces_in_groupfie || 'N/A'}
                </span>
              </div>
            </div>
          </Styled.ModalContainer>
        )}
      </Spin>
    </Modal>
  );
};

export default SummaryModal;